define(['jquery', 'jsb'], function ($, jsb) {

	var search_paths = '/ogs.html';
    var current_path = window.location.pathname;
    var $search_accordion = $('.ogs-live-search__content');

    if(search_paths.includes(current_path) && $search_accordion.length){
        // string & icon variables for livesearch
        var ls_data = {        
            "search_hint": "Durchsuchen Sie hier die Bankgeschäfte",
            "search_icon": '<svg class="icon-search module-contact__icon module-contact__icon--line-mail"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-search" href="#icon-search"></use></svg>',
            "search_placeholder": "Suchbegriff"
        }

        $(document.body).addClass('ogs-live-search');

        // find accordion that contains search content
        var $search_accordion = $('.ogs-live-search__content');
        var $register_content = $search_accordion.find('#reiter_249992410');
        var $register_tab = $register_content.parent('.acc-wrapper').addClass('ogs-live-search__register');

        // build search form
        var $search_form = $(`
            <div class="ogs-live-search__form">
                <label for="filter-input" class="search-label">${ls_data.search_hint}</label>            
                ${ls_data.search_icon}
            </div>
        `);
        var $filter_count = $('<div id="filter-count" class="search-subtext__grey"></div>');
        var $search_input = $(`<input type="text" class="search-input text-input" id="filter-input" value="" placeholder="${ls_data.search_placeholder}"/>`);
        var $no_result_content = $('.ogs-live-search__no-result');
        var $no_result_wrapper = $('<div class="ogs-live-search__no-result-wrapper" />').append($no_result_content);

        $search_form.append($search_input).append($filter_count);
        $search_accordion.before($search_form).before($no_result_wrapper);

        $search_input.keyup(function () {
            var filter = $(this).val(),
                count = 0;
        
            if (filter.length > 0) {
                $search_accordion.addClass('ogs-live-search__content--results');
            } else {                
                $search_accordion.removeClass('ogs-live-search__content--results');
            }
            
            $register_tab.find('.module-linklist').each(function(){
                var has_results = 0;
                var $linklist = $(this);
                $(this).find('a').each(function(){                    
                    
                    if ($(this).find('.module-linklist__title').text().search(new RegExp(filter, "i")) < 0) {
                        $(this).parent().addClass('ogs-live-search__no-match');
                    } else {
                        $(this).parent().removeClass('ogs-live-search__no-match');
                        count++;
                        has_results = 1;
                    }                    
                })
                if(has_results < 1){
                    $linklist.addClass('ogs-live-search__linklist--no-results');
                } else {
                    $linklist.removeClass('ogs-live-search__linklist--no-results');
                }
            }) 
            
            if (count != 0) {
                $("#filter-count").text(count + " Ergebnisse");                
                $no_result_wrapper.css("display", "none");
            } else {
                $("#filter-count").text(0 + " Ergebnisse");
                $no_result_wrapper.css("display", "block");
            };
       
            if (filter.length < 1) {
                $filter_count.text("");
            } 
        });
    }
});


